import { render, staticRenderFns } from "./AXprogramaestado.vue?vue&type=template&id=138fb3c7"
import script from "./AXprogramaestado.vue?vue&type=script&lang=js"
export * from "./AXprogramaestado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports